<script setup lang="ts">
import useStore from '@/stores/publicStore';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { setStorage } from '@/utils/storage';

// 获取 pinia 数据
const store = useStore();
const { isLogin } = storeToRefs(store);
const { changeUserInfo, changeVipInfo } = store;

const router = useRouter();

let url = window.location.href;

const fromSource = url
  ?.split('/brank?')[1]
  ?.split('&')
  ?.map(item => {
    return [item.split('=')[0], item.split('=')[1]];
  });
const token = fromSource?.find(item => item[0] === 'token');
if (token) {
  isLogin.value = true;
  setStorage('token', token[1]);
  changeUserInfo();
  changeVipInfo();
  router.push('/');
}
</script>

<template>
  <div full flex-center bg-white>正在跳转，请稍候...</div>
</template>
